import { useTranslation } from 'react-i18next';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

export const LoadingState = ({ message, className = 'h-64' }: LoadingStateProps) => {
  const { t } = useTranslation('courierInvoicesModule');
  const displayMessage = message || t('loading.list');

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-muted-foreground border-t-transparent mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">{displayMessage}</p>
      </div>
    </div>
  );
};
